
function http500ErrorInterceptor($q, $location) {
  return {
    responseError: function(response) {
      if (response.status === 500) {
        $location.path('/500');
        $location.replace();
      }
      return $q.reject(response);
    }
  };
}

http500ErrorInterceptor.$inject = ['$q', '$location'];

export default http500ErrorInterceptor;
